var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoredToDoList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "to-do-list 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5342 2.02491C20.1357 1.62595 19.6057 1.40625 19.0418 1.40625H4.97933C3.81753 1.40625 2.87127 2.35148 2.86995 3.51328L2.84961 21.8883C2.84895 22.4521 3.0681 22.9824 3.46658 23.3813C3.86511 23.7803 4.39513 24 4.95899 24H19.0215C20.1833 24 21.1296 23.0548 21.1309 21.893L21.1512 3.51797C21.1518 2.95411 20.9327 2.42386 20.5342 2.02491Z",
    fill: "#C1DBFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.5338 2.02491C20.1353 1.62595 19.6053 1.40625 19.0414 1.40625H12V24H19.0211C20.1829 24 21.1292 23.0548 21.1305 21.893L21.1508 3.51797C21.1514 2.95411 20.9323 2.42386 20.5338 2.02491Z",
    fill: "#C1DBFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.2188 2.8125H7.78125C7.52236 2.8125 7.3125 2.60264 7.3125 2.34375V0.46875C7.3125 0.209859 7.52236 0 7.78125 0H16.2188C16.4776 0 16.6875 0.209859 16.6875 0.46875V2.34375C16.6875 2.60264 16.4776 2.8125 16.2188 2.8125Z",
    fill: "#6E79DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.2188 0H12V2.8125H16.2188C16.4776 2.8125 16.6875 2.60264 16.6875 2.34375V0.46875C16.6875 0.209859 16.4776 0 16.2188 0Z",
    fill: "#6E79DE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.6986 9.84375H12.7031C12.3148 9.84375 12 9.52894 12 9.14062C12 8.75231 12.3148 8.4375 12.7031 8.4375H17.6986C18.087 8.4375 18.4018 8.75231 18.4018 9.14062C18.4018 9.52894 18.087 9.84375 17.6986 9.84375Z",
    fill: "#50B1BA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.6986 14.5312H12.7031C12.3148 14.5312 12 14.2164 12 13.8281C12 13.4398 12.3148 13.125 12.7031 13.125H17.6986C18.087 13.125 18.4018 13.4398 18.4018 13.8281C18.4018 14.2164 18.087 14.5312 17.6986 14.5312Z",
    fill: "#50B1BA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.7188 19.2188H12.7031C12.3148 19.2188 12 18.9039 12 18.5156C12 18.1273 12.3148 17.8125 12.7031 17.8125H17.7188C18.1071 17.8125 18.4219 18.1273 18.4219 18.5156C18.4219 18.9039 18.1071 19.2188 17.7188 19.2188Z",
    fill: "#50B1BA"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M7.62462 10.5454C7.43811 10.5454 7.25928 10.4713 7.12742 10.3395L6.2479 9.45991C5.97336 9.18531 5.97336 8.74014 6.2479 8.46555C6.5225 8.191 6.96767 8.191 7.24226 8.46555L7.62457 8.84791L9.24607 7.22645C9.52067 6.95186 9.96584 6.95186 10.2404 7.22645C10.515 7.50105 10.515 7.94622 10.2404 8.22081L8.12173 10.3395C7.98992 10.4714 7.81109 10.5454 7.62462 10.5454Z",
    fill: "#50B1BA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M7.62462 15.5904C7.43811 15.5904 7.25932 15.5164 7.12742 15.3844L6.2479 14.5049C5.97336 14.2303 5.97336 13.7851 6.2479 13.5105C6.5225 13.2359 6.96767 13.2359 7.24226 13.5105L7.62457 13.8928L9.24607 12.2713C9.52062 11.9968 9.96584 11.9968 10.2404 12.2713C10.515 12.5459 10.515 12.9911 10.2404 13.2657L8.12173 15.3844C7.98996 15.5164 7.81109 15.5904 7.62462 15.5904Z",
    fill: "#50B1BA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M7.62462 20.2779C7.43811 20.2779 7.25932 20.2039 7.12742 20.0719L6.2479 19.1924C5.97336 18.9178 5.97336 18.4726 6.2479 18.198C6.5225 17.9234 6.96767 17.9234 7.24226 18.198L7.62457 18.5803L9.24607 16.9588C9.52062 16.6843 9.96584 16.6843 10.2404 16.9588C10.515 17.2334 10.515 17.6786 10.2404 17.9532L8.12173 20.0719C7.98996 20.2039 7.81109 20.2779 7.62462 20.2779Z",
    fill: "#50B1BA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredToDoList);
export default __webpack_public_path__ + "static/media/colored-to-do-list.99465ae5361ace58d3321bc80c6b186c.svg";
export { ForwardRef as ReactComponent };